/* eslint-disable no-prototype-builtins */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable consistent-return */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-continue */
/* eslint-disable no-restricted-syntax */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import styles from './quiz.module.scss';
import Button from '../../../components/button';
import Loading from '../../../components/loading/loading';
import Modal from '../../../components/modal';

const StartQuiz = (props) => {
  const { handelSubmission, navigateToFailurePage, quizData, handleSaveContent, params, adp, translation, currentQuizz, handleQuizzStatus,
    currentAttempts, handleQuizAnswers, additional_config, retakeSection, trainingDraft, isPublic, loadingStatus, handleSaveQuizDraft,
  changeStepper, handleSaveQuizShuffle, retakeTrigger, trackingProgress, checkRecheckQuizz, retakeFailTraining } = props;
  const alphabet = 'ABCDEFGHIJK';

  // const metaData = { totalQuestions: 3, passingCriteria: 80, shuffle: true }
  let no_of_reattempts = useSelector(state => state?.permitManagement?.userData?.lms?.English?.sections) || [];
  no_of_reattempts = Number(no_of_reattempts?.[0]?.additional_config?.no_of_quiz_reattempts)+1 || 1;
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [error, setError] = useState(false);
  const [answers, setAnswers] = useState({});
  const [adpQuizes, setAdpQuizes] = useState([]);
  const [testAttempts, setTestAttempts] = useState({
    count: 0
  });
  const [modal, setModal]=useState(false);
  const [selectedImage, setSelectedImage] =useState('');
  const [quizSubmitted, setQuizSubmitted] = useState(false);
  const [missedQuestion, setMissedQuestion] = useState([]);

  let tracking;
  const trainingDraftFromState = useSelector(state => state.trainings.trainingDraft);
  if (isPublic) {
    tracking = trainingDraft;
  } else {
    tracking = trainingDraftFromState;
  }

  const loader = useSelector(state => state.trainings.saveContentAction);

  let success;
  if (isPublic) {
    success = loadingStatus;
  } else {
    success = loader?.success;
  }

  useEffect(() => {
    const handlePopState = () => {
      if (additional_config?.content_restricted === true) {
        window.history.pushState(null, '', window.location.href);
      }
    };

    if (additional_config?.content_restricted === true) {
      window.history.pushState(null, '', window.location.href);
      window.addEventListener('popstate', handlePopState);
    }

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [additional_config]);

  const handleSelect = (id, ans) => {
    const res = { ...answers };
    if (!res.hasOwnProperty(id)) {
      res[id] = [ans];
    } else if (res[id].includes(ans)) {
      res[id] = res[id].filter(el => (el !== ans));
    } else {
      res[id].push(ans);
    }
    setAnswers(res);
    if (!adp) handleSaveQuizDraft(res);
    if (!selectedAnswers.hasOwnProperty(id)) {
      setSelectedAnswers({ ...selectedAnswers, [id]: [ans] });
    } else if (selectedAnswers.hasOwnProperty(id)) {
      if (selectedAnswers[id].includes(ans)) {
        const result = selectedAnswers[id].filter(ele => ele !== ans);
        setSelectedAnswers({ ...selectedAnswers, [id]: result });
      } else {
        setSelectedAnswers({ ...selectedAnswers, [id]: [...selectedAnswers[id], ans] });
      }
    }
    setError(false);
    setMissedQuestion([]);
  };

  const checkTrainingTaken = (result) => {
    if (quizData?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
      && quizData?.additional_config?.whenReattemptFail === 'Mandatory Wait Time until Reattempt') {
      if (result === 'pass') {
        return true;
      }
      return false;
    }
    return currentAttempts < no_of_reattempts;
  };

  const handleSubmit = () => {
    let mark = 0;
    let adpMarks = 0;
    let totalQuizMarks = 0;
    // let totalCorrectAnswers = 0;
    if (adp) {
      adpQuizes.forEach((ele) => {
        totalQuizMarks += Number(ele.marks);
        for (const key in answers) {
          if (key === ele.id) {
            const adpCorrecctAnswers = [];
            ele.values.forEach((el) => {
              if (el.correct_answer) {
                adpCorrecctAnswers.push(el.value);
              }
            });
            if (adpCorrecctAnswers.length === answers[key].length) {
              const selectedAns = answers[key];
              let flag = true;
              for (let i = 0; i < selectedAns.length; i++) {
                if (adpCorrecctAnswers.includes(selectedAns[i])) { continue; } else { flag = false; }
              }
              adpMarks += flag ? Number(ele.marks) : 0;
              // totalCorrectAnswers += flag ? 1 : 0;
            }
          }
        }
      });
    }

    if (!adp) {
      quizData.schema.fields.forEach((ele) => {
        for (const key in answers) {
          if (key === ele.id) {
            const correctAns = [];
            ele.values.forEach((el) => {
              if (el.correct_answer) {
                correctAns.push(el.value);
              }
            });
            if (correctAns.length === answers[key].length) {
              const selectedAns = answers[key];
              let flag = true;
              for (let i = 0; i < selectedAns.length; i++) {
                if (correctAns.includes(selectedAns[i])) { continue; } else { flag = false; }
              }
              mark += flag ? Number(ele.marks) : 0;
            }
          }
        }
      });
    }
    const { schema_id, id } = quizData;
    const form_id = Number(id);
    let checkAnsLength = 0;
    for (const k in selectedAnswers) {
      if (selectedAnswers[k].length !== 0) {
        checkAnsLength += 1;
      }
    }
    if (currentQuizz?.type === 'Re-attempts quiz for wrong answers only'
      && currentQuizz?.retake_fail_question
      && currentQuizz?.failedQuestionIds?.length) {
      if (checkAnsLength === adpQuizes.length) {
        const currentQuizAns = tracking?.quiz_ans?.find(
          ele => Number(ele?.form_id) === Number(params?.subId)
          && Number(ele?.section_id) === Number(params?.id)
        );
        const previousMarks = Number(currentQuizAns?.obtained_marks || 0);
        const newMarks = Number(mark || 0);
        const combinedMarks = previousMarks + newMarks;
        const marks_data = { obtained_marks: combinedMarks, pass_marks: quizData.pass_marks };
        const quiz = { isedit: true, selectedAnswers };
        handleSaveContent(quiz, schema_id, form_id, marks_data);
        setQuizSubmitted(true);
        setError(false);
        setMissedQuestion([]);
      } else {
        const result = adpQuizes
          .map((item, index) => ({ item, index }))
          .filter(({ item }) => (!selectedAnswers.hasOwnProperty(item.id) || selectedAnswers[item.id]?.length <= 0))
          .map(({ index }) => index + 1);
        setMissedQuestion(result);
        setError(true);
      }
    } else if (adp
      && quizData?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
      && currentQuizz?.quiz?.retake_fail_question
      && currentQuizz?.quiz?.failedQuestionIds?.length
    ) {
      if (checkAnsLength === adpQuizes.length) {
        const quizAttempts = localStorage.getItem('testAttemps');
        const currentQuizAns = currentQuizz?.quiz;
        const previousMarks = Number(currentQuizAns?.obtained_marks || 0);
        const newMarks = Number(adpMarks || 0);
        const combinedMarks = previousMarks + newMarks;
        const marks_data = { obtained_marks: combinedMarks, pass_marks: quizData.pass_marks, total_marks: totalQuizMarks };
        setError(false);
        let num = testAttempts.count;
        setTestAttempts({ count: num + 1 });
        let result = '';
        if (marks_data && marks_data.pass_marks) {
          if (Number(marks_data?.obtained_marks) >= Number(marks_data?.pass_marks)) {
            result = 'pass';
          } else if (
            Number(quizAttempts) >= Number(currentQuizz?.quiz?.total_reattempts)
            && Number(marks_data?.obtained_marks) < Number(marks_data?.pass_marks)
          ) {
            result = 'fail';
          }
        }
        let tracking_info = {
          quiz: {
            attempt_date: new Date(),
            ...marks_data,
            schema_id,
            form_id,
            response: {
              ...selectedAnswers,
              ...currentQuizAns.response
            },
            shuffleQuiz: adpQuizes.map(item => item.id),
            total_reattempts: quizData?.additional_config?.no_of_quiz_reattempts,
            need_to_reattempt: quizData?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
              && quizData?.additional_config?.whenReattemptFail === 'Mandatory Wait Time until Reattempt'
              && result !== 'pass',
            type: quizData?.additional_config?.whenQuizFail,
            final_result: result
          },
          trainingTaken: result === 'pass',
          testAttempts: Number(quizAttempts) + 1,
          last_index: null,
          last_content_id: null,
          last_pdf_num: null,
          training_status: result === 'fail' ? 'Fail' : 'Pass',
          test_taken: result === 'pass'
        };
        handelSubmission({ tracking_info, quiz: { ...tracking_info.quiz } }, 'quiz');
        setAnswers({});
        setSelectedAnswers({});
        if (result === 'fail') {
          const isMandatoryWaitCondition = quizData?.additional_config?.no_of_days_to_mandate_for_reattempts_failure
            && quizData?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
            && quizData?.additional_config?.whenReattemptFail === 'Mandatory Wait Time until Reattempt';
          if (!isMandatoryWaitCondition) {
            navigateToFailurePage('fail', false);
            changeStepper('certificate');
          }
        } else {
          tracking_info = {
            ...tracking_info,
            tracking_info: {
              ...tracking_info,
              trainingTaken: true,
              training_status: 'Pass',
              test_taken: true
            }
          };
          localStorage.removeItem('traningAttemps');
          handelSubmission(tracking_info, 'quiz');
        }
      } else {
        const result = adpQuizes
          .map((item, index) => ({ item, index }))
          .filter(({ item }) => (!selectedAnswers.hasOwnProperty(item.id) || selectedAnswers[item.id]?.length <= 0))
          .map(({ index }) => index + 1);
        setMissedQuestion(result);
        setError(true);
      }
    } else if (checkAnsLength === quizData.schema.fields.length
      || (checkAnsLength !== 0 && checkAnsLength === Number(quizData?.meta_data?.totalQuestions))) {
      let marks_data = { obtained_marks: mark, pass_marks: quizData.pass_marks };
      const quiz = { istrue: true, selectedAnswers };
      // logic for adp quizes
      if (adp) {
        handleQuizAnswers(answers);
        const quizAttempts = localStorage.getItem('testAttemps');
        let marks_data = { obtained_marks: adpMarks, pass_marks: quizData.pass_marks, total_marks: totalQuizMarks };
        if (quizData?.pass_marks) {
          if (Number(quizData?.pass_marks) <= Number(marks_data?.obtained_marks)) {
            marks_data = {
              quiz: { ...marks_data, schema_id, form_id, response: selectedAnswers },
              trainingTaken: true,
              test_taken: true,
              testAttempts: Number(quizAttempts)+1,
              last_index: null,
              last_content_id: null,
              last_pdf_num: null
            };
            marks_data = { ...marks_data, tracking_info: { ...marks_data, training_status: 'Pass' } };
            localStorage.removeItem('traningAttemps');
            handelSubmission(marks_data, 'quiz');
          } else {
            let num = testAttempts.count;
            setTestAttempts({ count: num+1 });
            let result = '';
            if (marks_data && marks_data.pass_marks) {
              if (Number(marks_data?.obtained_marks) >= Number(marks_data?.pass_marks)) {
                result = 'pass';
              } else if (
                Number(quizAttempts) >= Number(currentQuizz?.quiz?.total_reattempts)
                && Number(marks_data?.obtained_marks) < Number(marks_data?.pass_marks)
              ) {
                result = 'fail';
              }
            }
            let tracking_info = {
              quiz: {
                attempt_date: new Date(),
                ...marks_data,
                schema_id,
                form_id,
                response: selectedAnswers,
                shuffleQuiz: adpQuizes.map(item => item.id),
                total_reattempts: quizData?.additional_config?.no_of_quiz_reattempts,
                need_to_reattempt: quizData?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
                  && quizData?.additional_config?.whenReattemptFail === 'Mandatory Wait Time until Reattempt'
                  && result !== 'pass',
                type: quizData?.additional_config?.whenQuizFail,
                final_result: result
              },
              trainingTaken: checkTrainingTaken(result),
              testAttempts: Number(quizAttempts)+1,
              last_index: null,
              last_content_id: null,
              last_pdf_num: null,
              training_status: 'Fail'
            };

            handelSubmission({ tracking_info, quiz: { ...tracking_info.quiz } }, 'quiz');
            setAnswers({});
            setSelectedAnswers({});
            const isMandatoryWaitCondition = quizData?.additional_config?.no_of_days_to_mandate_for_reattempts_failure
              && quizData?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
              && quizData?.additional_config?.whenReattemptFail === 'Mandatory Wait Time until Reattempt';
            if (!isMandatoryWaitCondition) {
              navigateToFailurePage('fail', false);
              changeStepper('certificate');
            }
          }
        } else if (marks_data.obtained_marks >= marks_data.pass_marks) {
          marks_data = {
            quiz: { ...marks_data },
            test_taken: true,
            testAttempts: Number(quizAttempts)+1,
            last_index: null,
            last_content_id: null,
            last_pdf_num: null
          };
          marks_data = { ...marks_data, tracking_info: { ...marks_data, trainingTaken: true, training_status: 'Pass' } };
          localStorage.removeItem('traningAttemps');
          handelSubmission(marks_data, 'quiz');
        } else {
          let num = testAttempts.count;
          setTestAttempts({ count: num+1 });
          let result = '';
          if (marks_data && marks_data.pass_marks) {
            if (Number(marks_data?.obtained_marks) >= Number(marks_data?.pass_marks)) {
              result = 'pass';
            } else if (
              Number(quizAttempts) >= Number(currentQuizz?.quiz?.total_reattempts)
              && Number(marks_data?.obtained_marks) < Number(marks_data?.pass_marks)
            ) {
              result = 'fail';
            }
          }
          let tracking_info = {
            trainingTaken: false,
            quiz: {
              attempt_date: new Date(),
              ...marks_data,
              schema_id,
              form_id,
              response: selectedAnswers,
              shuffleQuiz: adpQuizes.map(item => item.id),
              total_reattempts: quizData?.additional_config?.no_of_quiz_reattempts,
              need_to_reattempt: quizData?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
                && quizData?.additional_config?.whenReattemptFail === 'Mandatory Wait Time until Reattempt'
                && result !== 'pass',
              type: quizData?.additional_config?.whenQuizFail,
              final_result: result
            },
            testAttempts: Number(quizAttempts)+1,
            last_index: null,
            last_content_id: null,
            last_pdf_num: null,
            training_status: 'Fail'
          };
          handelSubmission({ tracking_info, quiz: { ...tracking_info.quiz } }, 'quiz');
          setAnswers({});
          setSelectedAnswers({});
          const isMandatoryWaitCondition = quizData?.additional_config?.no_of_days_to_mandate_for_reattempts_failure
            && quizData?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
            && quizData?.additional_config?.whenReattemptFail === 'Mandatory Wait Time until Reattempt';
          if (!isMandatoryWaitCondition) {
            navigateToFailurePage('fail', false);
            changeStepper('certificate');
          }
        }
      } else {
        handleSaveContent(quiz, schema_id, form_id, marks_data);
      }
      setError(false);
      setMissedQuestion([]);
    } else {
      const result = adpQuizes
        .map((item, index) => ({ item, index }))
        .filter(({ item }) => (!selectedAnswers.hasOwnProperty(item.id) || selectedAnswers[item.id]?.length <= 0))
        .map(({ index }) => index + 1);
        setMissedQuestion(result);
      setError(true);
    }
  };

  const CheckQuizStatus = () => {
    const currentQuiz=tracking?.quiz_ans?.find(ele => Number(ele?.form_id)===Number(params?.subId) && Number(ele?.section_id) === Number(params?.id));
    let result = Number(currentQuiz?.obtained_marks)>=Number(currentQuiz?.pass_marks);
    if (currentQuizz?.type === 'Re-attempts quiz for wrong answers only' && currentQuizz?.retake_fail_question) {
      handleQuizzStatus(false, result);
      return false;
    }
    const res = tracking?.quiz_ans?.filter((ele) => {
      if (ele.schema.id === quizData.id && ele.section_id === params?.id.toString()) {
        return ele;
      }
      return null;
    });
    if (res?.length === 0) {
      if (!adp) {
        handleQuizzStatus(false, result);
      }
      return false;
    }
    if (!adp) {
      handleQuizzStatus(true, result);
    }
    if (adp && trackingProgress?.quiz?.need_to_reattempt) {
      return false;
    }
    return true;
  };

  const getreport = () => {
    let totalMarks = 0;
    let currentQuiz = tracking?.quiz_ans?.find(ele => Number(ele?.form_id) === Number(params?.subId)
      && Number(ele?.section_id) === Number(params?.id));
    if (adp) {
      currentQuiz = trackingProgress?.quiz;
    }
    const selectedKeys = Object.keys(currentQuiz?.response);
    if (quizData?.schema?.fields) {
      totalMarks = quizData?.schema?.fields?.filter(q => selectedKeys.includes(q.id))
        .reduce((sum, q) => sum + Number(q.marks), 0);
      if (Number(currentQuiz?.obtained_marks) >= Number(currentQuiz?.pass_marks)) {
        return (
          <div>
            <h3 style={{ margin: 0 }}>Result : Pass</h3>
            <h3 style={{ margin: '1%', whiteSpace: 'pre' }}>{`Score : ${currentQuiz?.obtained_marks ||0}/${totalMarks}`}</h3>
          </div>
        );
      }

      return (
        <>
          <div className={styles.resultPage}>
            <div className={styles.resultCard}>
              <h3 style={{ margin: 0 }}>Result : Fail</h3>
              <h3 style={{ margin: '1%', whiteSpace: 'pre' }}>{`Score : ${currentQuiz?.obtained_marks || 0}/${totalMarks}`}</h3>
              &nbsp;
              {typeof checkRecheckQuizz === 'function' && checkRecheckQuizz() && adp
                && <Button
                  onClick={() => { retakeFailTraining(); }}
                  translationID="lms.add.quiz.finish1"
                  defaultText="Retake"
                  className={styles.retakeButton}
                />
              }
              {(Number(currentQuizz?.attempts) >= Number(currentQuizz?.total_reattempts) || (!currentQuizz?.total_reattempts))
                && (
                  <h3 style={{ margin: '1%', whiteSpace: 'pre' }}>
                  {adp
                    ? `Total Reattempts : ${Number(currentQuizz?.testAttempts) || 0}/${Number(currentQuizz?.quiz?.total_reattempts) || 0}`
                    : `Total Reattempts : ${Number(currentQuizz?.total_reattempts) || 0}`
                  }
                  </h3>
                )
              }
              {validateFailReattemptTimer() && (
                <>
                  {checkFailRetakeError()}
                </>
              )}
              {additional_config?.whenQuizFail === 'Re-take Section' && (
                <Button
                  onClick={() => { retakeSection(); }}
                  translationID="lms.add.quiz.finish1"
                  defaultText="Retake"
                  className={styles.completeButton}
                />
              )}
            </div>
          </div>
        </>
      );
    }
    return null;
  };

  const getImageUrl= (id) => {
    let url='';
    if (quizData?.attachments?.length>0) {
      quizData.attachments.forEach((each) => {
        if (each?.attachment_id === id) {
          url= each?.url;
        }
      });
    }
    return url;
  };


  useEffect(() => {
    if (quizSubmitted && success) {
      setSelectedAnswers({});
      setAnswers({});
      setQuizSubmitted(false);
    }
  }, [success, setSelectedAnswers, setAnswers]);

  useEffect(() => {
    if (tracking && adpQuizes) {
      const trackingData = tracking?.tracking_info;
      const attempt = trackingData?.attempts_used?.[currentQuizz?.index];
      if (attempt?.quizDraft) {
        const filteredData = Object.keys(attempt?.quizDraft).reduce((acc, key) => {
          const matchingItem = adpQuizes.find(item => item.id === key);
          if (matchingItem) {
            acc[key] = attempt?.quizDraft[key];
          }
          return acc;
        }, {});
        if (attempt) {
          setAnswers(filteredData || {});
          setSelectedAnswers(filteredData || {});
        }
      }
    }
  }, [tracking, currentQuizz, adpQuizes]);

  const checkAdpQuizStatus = () => {
    if (quizData?.test_taken) {
      return true;
    }
    return false;
  };

  // restart state when user change quiz of specific section
  useEffect(() => {
    setAnswers({});
    setSelectedAnswers({});
    setMissedQuestion([]);
    setAdpQuizes([]);
    setError(false);
  }, [quizData?.id]);

  const isQuizCompleted = () => {
    const currentQuiz = tracking?.quiz_ans?.find(
      ele => Number(ele?.form_id) === Number(params?.subId)
        && Number(ele?.section_id) === Number(params?.id)
    );

    // Allow retake flow
    if (
      currentQuizz?.type === 'Re-attempts quiz for wrong answers only'
      && currentQuizz?.retake_fail_question
    ) {
      return false;
    }

    // Allow normal reattempts also
    if (
      currentQuizz?.type === 'Re-attempts Allowed'
      && Number(currentQuizz?.attempts) <= Number(currentQuizz?.total_reattempts)
      && currentQuizz?.current_attempt_result !== 'pass'
    ) {
      return false;
    }

    return !!currentQuiz;
  };

useEffect(() => {
  if (isQuizCompleted()) return;
  if (quizSubmitted) return;

  if (!adpQuizes?.length) {
    const metaData = quizData?.meta_data || {};
    const quiz_data = quizData?.schema?.fields || [];

    if (!quiz_data.length) return;

    let quizes = [];

    const shouldUseExistingShuffleOrder = Boolean(metaData?.shuffle)
      && currentQuizz?.type === 'Re-attempts Allowed'
      && Number(currentQuizz?.attempts) !== 1
      && currentQuizz?.attempts <= currentQuizz?.total_reattempts
      && currentQuizz?.shuffleQuiz?.length !== 0;

    // Failed questions only
    if (currentQuizz?.type === 'Re-attempts quiz for wrong answers only'
      && currentQuizz?.retake_fail_question
      && currentQuizz?.failedQuestionIds?.length
    ) {
      if (currentQuizz?.shuffleQuiz?.length !== 0) {
        quizes = currentQuizz?.shuffleQuiz.map(id => quiz_data.find(q => q.id === id));
      } else {
        quizes = quiz_data;
      }
      quizes = quizes.filter(q => currentQuizz.failedQuestionIds.includes(q.id));
    } else if (shouldUseExistingShuffleOrder) {
      quizes = currentQuizz.shuffleQuiz
        .map(id => quiz_data.find(q => q.id === id))
        .filter(Boolean);
    } else if (
      metaData?.totalQuestions && (quizes.length >= metaData?.totalQuestions || quiz_data.length >= metaData?.totalQuestions)
    ) {
      if (metaData?.shuffle) {
        quizes = [...quiz_data].sort(() => Math.random() - 0.5);
        quizes = quizes.slice(0, Number(metaData.totalQuestions));
      } else {
        quizes = quiz_data.slice(0, Number(metaData.totalQuestions));
      }
    } else if (metaData?.shuffle) {
      quizes = [...quiz_data].sort(() => Math.random() - 0.5);
    } else {
      quizes = quiz_data;
    }
    if (adp) {
      if (quizData?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
        && currentQuizz?.quiz?.retake_fail_question
        && currentQuizz?.quiz?.failedQuestionIds?.length
      ) {
        if (currentQuizz?.quiz?.shuffleQuiz?.length !== 0) {
          quizes = currentQuizz?.quiz?.shuffleQuiz.map(id => quiz_data.find(q => q.id === id));
        } else {
          quizes = quiz_data;
        }
        quizes = quizes.filter(q => currentQuizz.quiz?.failedQuestionIds.includes(q.id));
      }
    }

    setAdpQuizes(quizes);

    if (!adp && quizes.length > 0) {
      const quizIDs = quizes.map(item => item.id);
      handleSaveQuizShuffle(quizIDs);
    }
  }
}, [quizData, adpQuizes?.length, currentQuizz, retakeTrigger]);

  const validateReattemptTimer = () => {
    let publicTestAttempts = JSON.parse(localStorage.getItem('testAttemps'));
    if (quizData?.additional_config?.no_of_days_to_mandate
      && quizData?.additional_config?.whenQuizFail==='Mandatory Wait Time until Test can be Retaken'
      && (new Date().getTime() - new Date(trackingProgress?.quiz?.attempt_date).getTime()) / (1000 * 60 * 60 * 24)
        < Number(props.quizData.additional_config?.no_of_days_to_mandate)) {
      return true;
    }
    if (quizData?.additional_config?.no_of_days_to_mandate_for_reattempts_failure
      && quizData?.additional_config?.whenQuizFail === 'Re-attempts Allowed'
      && (trackingProgress?.testAttempts >= +quizData?.additional_config?.no_of_quiz_reattempts
      || publicTestAttempts >= +quizData?.additional_config?.no_of_quiz_reattempts)
      && (new Date().getTime() - new Date(trackingProgress?.quiz?.attempt_date).getTime()) / (1000 * 60 * 60 * 24)
        < Number(props.quizData.additional_config?.no_of_days_to_mandate_for_reattempts_failure)) {
        return true;
    }
    return false;
  };

  const checkRetakeError = () => {
      if (quizData?.additional_config?.whenQuizFail === 'Mandatory Wait Time until Test can be Retaken'
        && (new Date().getTime() - new Date(trackingProgress?.quiz?.attempt_date).getTime()) / (1000 * 60 * 60 * 24)
        <= Number(props.quizData.additional_config?.no_of_days_to_mandate)) {
        const timeLeft = Number(props.quizData.additional_config?.no_of_days_to_mandate)
          - (new Date().getTime() - new Date(trackingProgress?.quiz?.attempt_date).getTime()) / (1000 * 60 * 60 * 24);
        const days = Math.floor(timeLeft);
        const hours = Math.floor((timeLeft - days) * 24);
        return `You can attempt to retake the assessment in ${days} day${days > 1 ? 's' : ''} ${hours} hour${hours > 1 ? 's' : ''}`;
      }
      if (quizData?.additional_config?.whenQuizFail === 'Re-attempts Allowed') {
        const timeLeft = Number(props.quizData.additional_config?.no_of_days_to_mandate_for_reattempts_failure)
          - (new Date().getTime() - new Date(trackingProgress?.quiz?.attempt_date).getTime()) / (1000 * 60 * 60 * 24);
        const days = Math.floor(timeLeft);
        const hours = Math.floor((timeLeft - days) * 24);
        return `You can attempt to retake the assessment in ${days} day${days > 1 ? 's' : ''} ${hours} hour${hours > 1 ? 's' : ''}`;
      }
    };

  const validateFailReattemptTimer = () => {
    if (adp) {
      if (quizData?.additional_config?.no_of_days_to_mandate_for_reattempts_failure
      && quizData?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
      && quizData?.additional_config?.whenReattemptFail === 'Mandatory Wait Time until Reattempt'
      && (new Date().getTime() - new Date(currentQuizz?.quiz?.attempt_date).getTime()) / (1000 * 60 * 60 * 24)
      < Number(quizData?.additional_config?.no_of_days_to_mandate_for_reattempts_failure)) {
      return true;
    }
    }
    if (additional_config?.no_of_days_to_mandate_for_reattempts_failure
      && additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
      && additional_config?.whenReattemptFail === 'Mandatory Wait Time until Reattempt'
      && (new Date().getTime() - new Date(currentQuizz?.attempt_date).getTime()) / (1000 * 60 * 60 * 24)
      < Number(additional_config?.no_of_days_to_mandate_for_reattempts_failure)) {
      return true;
    }
    return false;
  };

  const checkFailRetakeError = () => {
    if (adp) {
      if (quizData?.additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
        && quizData?.additional_config?.whenReattemptFail === 'Mandatory Wait Time until Reattempt'
        && currentQuizz?.testAttempts === Number(currentQuizz?.quiz?.total_reattempts)
        && (new Date().getTime() - new Date(currentQuizz?.quiz?.attempt_date).getTime()) / (1000 * 60 * 60 * 24)
        <= Number(quizData?.additional_config?.no_of_days_to_mandate_for_reattempts_failure)) {
        const timeLeft = Number(quizData?.additional_config?.no_of_days_to_mandate_for_reattempts_failure)
          - (new Date().getTime() - new Date(currentQuizz?.quiz?.attempt_date).getTime()) / (1000 * 60 * 60 * 24);
        const days = Math.floor(timeLeft);
        const hours = Math.floor((timeLeft - days) * 24);
        return `Next Attempt will be available in ${days} day${days > 1 ? 's' : ''} ${hours} hour${hours > 1 ? 's' : ''}`;
      }
    }
    if (additional_config?.whenQuizFail === 'Re-attempts quiz for wrong answers only'
      && additional_config?.whenReattemptFail === 'Mandatory Wait Time until Reattempt'
      && currentQuizz?.attempts === currentQuizz?.total_reattempts
      && (new Date().getTime() - new Date(currentQuizz?.attempt_date).getTime()) / (1000 * 60 * 60 * 24)
      <= Number(additional_config?.no_of_days_to_mandate_for_reattempts_failure)) {
      const timeLeft = Number(additional_config?.no_of_days_to_mandate_for_reattempts_failure)
        - (new Date().getTime() - new Date(currentQuizz?.attempt_date).getTime()) / (1000 * 60 * 60 * 24);
      const days = Math.floor(timeLeft);
      const hours = Math.floor((timeLeft - days) * 24);
      return `Next Attempt will be available in ${days} day${days > 1 ? 's' : ''} ${hours} hour${hours > 1 ? 's' : ''}`;
    }
  };


    return (
  <>
    {/* quiz questions */}
    {<Loading loadingStatus={loader.loading} />}
    {(adp ? !CheckQuizStatus() : CheckQuizStatus()) ? <h3 className={`${adp ? styles.completedADPQuiz : styles.completedQuiz}`}>{getreport()}</h3> : (
      <>{checkAdpQuizStatus() ? <>Quiz submited</> : (
      <>
        {quizData?.id !== undefined && (
          <div className={styles.parrentContainer}
            style={{
              width: adp ? '100%' : '',
              background: adp ? 'none' : '',
              borderTop: adp ? '1px solid #E6EAEE' : ''
            }}
          >
            {validateReattemptTimer() ? <p className="mt-5 d-flex justify-content-center">{checkRetakeError()}</p>
            :adp && quizData?.meta_data && adpQuizes?.map((ele, i) => (
              <div className={`${adp ? styles.adpChalangeContainer : styles.chalengeContainer}`} key={ele.title} style={{ width: adp ? '100%' : '' }}>
                <h4 className={styles.questionText}>
                  {translation?.question}
                  {/* Question */}
                  {' '}
                  {i + 1}
                </h4>
                <h4 className={styles.question}>
                  {ele.title}
                </h4>
                {ele?.attachments && (
                <>
                  <img onClick={() => { setModal(true); setSelectedImage(ele?.attachments[0]); }}
                  src={getImageUrl(ele?.attachments[0])} className={styles.qtnImage} alt="" />
                  <Modal
                  showIn={modal}
                  onClose={() => setModal(false)}
                  width="60%"
                  contentStyles={{
                  height: '60%',
                  overflow: 'auto'
                  }}
                  >
                  <img src={getImageUrl(selectedImage)} height="100%" alt="" />
                  </Modal>
                </>
                )}
                {ele.values.map((opt, i) => (
                  <div className={styles.optionContainer} key={opt.key}>
                    <h3
                      className={`${props?.canEdit !== undefined
                        ? styles.optionNumber1 : styles.optionNumber} ${selectedAnswers?.[ele?.id]?.includes(opt.value)
                          ? styles.selectedAns : ''}`}
                      onClick={() => { handleSelect(ele.id, opt.value); }}
                    >
                      {alphabet[i]}
                    </h3>
                    <p
                      className={props?.canEdit !== undefined ? styles.option1 : styles.option}
                      onClick={() => { handleSelect(ele.id, opt.value); }}
                    >
                      {opt.value}
                    </p>
                  </div>
                ))}
              </div>
            ))}
            {!adp && adpQuizes?.map((ele, i) => (
              <div className={`${adp ? styles.adpChalangeContainer : styles.chalengeContainer}`} key={ele.title} style={{ width: adp ? '100%' : '' }}>
                <h4 className={styles.questionText}>
                  Question
                  {' '}
                  {i + 1}
                </h4>
                <h4 className={styles.question}>
                  {ele.title}
                </h4>
                {ele?.attachments && (
                <>
                  <img onClick={() => { setModal(true); setSelectedImage(ele?.attachments[0]); }}
                  src={getImageUrl(ele?.attachments[0])} className={styles.qtnImage} alt="" />
                  <Modal
                  showIn={modal}
                  onClose={() => setModal(false)}
                  width="60%"
                  contentStyles={{
                  height: '60%',
                  overflow: 'auto'
                  }}
                  >
                  <img src={getImageUrl(selectedImage)} height="100%" alt="" />
                  </Modal>
                </>
                )}
                {ele.values.map((opt, i) => (
                  <div className={styles.optionContainer} key={opt.key}>
                    <h3
                      className={`${props?.canEdit !== undefined
                        ? styles.optionNumber1 : styles.optionNumber} ${selectedAnswers?.[ele?.id]?.includes(opt.value)
                          ? styles.selectedAns : ''}`}
                      onClick={() => { handleSelect(ele.id, opt.value); }}
                    >
                        {alphabet[i]}
                    </h3>
                    <p
                      className={props?.canEdit !== undefined ? styles.option1 : styles.option}
                      onClick={() => { handleSelect(ele.id, opt.value); }}
                    >
                      {opt.value}
                    </p>
                  </div>
                ))}
              </div>
            ))}
            {/* {} */}
                {error
                  && <p style={{ color: 'red', marginLeft: adp ? '2%' : '18%' }}>
                    {adp
                      ? translation.quizError
                      : `${missedQuestion.map(item => `Question ${item}`).join(', ')} ${missedQuestion.length === 1 ? 'is' : 'are'} missed`
                    }
                     </p>
                }
            {/* action buttons */}
            {(!adp||!validateReattemptTimer()) && (
            <div className={styles.actionBtn}
              style={{ width: props?.adp ? '100%' : '', marginRight: '' }}
            >
              <Button
                onClick={() => { handleSubmit(); }}
                translationID="training.add.quiz.finis"
                defaultText={'Submit'}
                className={styles.finshBtn}
              />
            </div>)}
          </div>
        )}
      </>)}
      </>)}
  </>);
};

export default StartQuiz;
